import * as React from 'react';
import {ReactElement, Component  } from 'react';
import './styles.sass';

interface IVideoSettingsAudioMeterProps {
  disabled: boolean;
  stream: MediaStream;
}

export class VideoSettingsAudioMeter extends Component<IVideoSettingsAudioMeterProps, {}> {
  private canvasElement: HTMLCanvasElement;
  private canvasContext: CanvasRenderingContext2D;
  private audioContext: AudioContext;
  private processor: any;
  private analyser: any;

  public constructor(props: IVideoSettingsAudioMeterProps) {
    super(props);

    this.audioContext = new ((window as any).AudioContext || (window as any).webkitAudioContext)();
  }

  public render(): ReactElement<any> {
    return (
      <div className={'video-settings-audio-meter'}>
        <i className={'fa fa-microphone video-settings-audio-meter__icon'} />

        <canvas
          className={'video-settings-audio-meter__canvas'}
          height={20}
          width={160}
          ref={this.setCanvas}
        />
      </div>
    );
  }

  public componentDidMount(): void {
    this.connectToStream(this.props.stream);
  }

  public componentDidUpdate(): void {
    this.toggle();
  }

  public componentWillUnmount(): void {
    if (this.audioContext) {
      this.audioContext.close();
    }
  }

  private connectToStream = (stream) => {
    if (stream) {
      const microphone = this.audioContext.createMediaStreamSource(stream);
      const analyser = this.audioContext.createAnalyser();
      const processor = this.audioContext.createScriptProcessor(1024, 1, 1);

      analyser.smoothingTimeConstant = 0.8;
      analyser.fftSize = 512;

      microphone.connect(analyser);
      analyser.connect(processor);
      processor.addEventListener('audioprocess', this.onAudioProcess);
      processor.connect(this.audioContext.destination);

      this.analyser = analyser;
      this.processor = processor;
    }
  }

  private onAudioProcess = (event) => {
    const inputData: Uint8Array = new Uint8Array(this.analyser.frequencyBinCount);
    this.analyser.getByteFrequencyData(inputData);

    const average: number = inputData.reduce((sum, value) => sum += value, 0) / inputData.length;

    this.updateCanvas(average);
  }

  private updateCanvas = (average: number) => {
    const {width, height} = this.canvasElement;

    this.canvasContext.clearRect(0, 0, width, height);

    this.canvasContext.fillStyle = '#138b6b';
    this.canvasContext.fillRect(average - width, 0, width, height);
  }

  private setCanvas = (node: HTMLCanvasElement) => {
    if (node) {
      this.canvasContext = node.getContext('2d');
      this.canvasElement = node;
    }
  }

  private toggle = () => {
    if (this.props.disabled && this.processor) {
      this.updateCanvas(0);
      this.processor.removeEventListener('audioprocess', this.onAudioProcess);
    } else {
      this.connectToStream(this.props.stream);
    }
  }
}
